import { useQuizModalStore } from "@/zustand/quizModalStore.js";
import Modal from "@/components/Modal/Modal";
import QuizStart from "@/components/Quiz/QuizStart/QuizStart";
import QuizQuestions from "@/components/Quiz/QuizQuestions/QuizQuestions";
import QuizEnd from "@/components/Quiz/QuizEnd/QuizEnd";

const QuizModal = () => {
  const { isQuizModalOpen, closeQuizModal, quizPhase, step, nextStep, setQuizPhase, setQuizCompleted } =
    useQuizModalStore();

  if (!isQuizModalOpen) return null;

  let content;
  let style;
  switch (quizPhase) {
    case "intro":
      content = <QuizStart onNext={() => setQuizPhase("quiz")} />;
      style = { justifyContent: "initial", marginTop: "80px" };
      break;
    case "quiz":
      content = <QuizQuestions onNext={nextStep} step={step} />;
      style = { justifyContent: "initial", marginTop: "40px" };
      break;
    case "loader":
      content = (
        <QuizEnd
          onComplete={() => {
            setQuizCompleted(true);
            closeQuizModal();
          }}
        />
      );
      style = { justifyContent: "flex-start", marginTop: "44px" };
      break;
  }

  return <Modal content={content} style={style} />;
};

export default QuizModal;
